import common_en from '../locales/en/common.json';
import auth_en from '../locales/en/auth.json';
import welcome_en from '../locales/en/welcome.json';

import { LOCALES } from './constants';

export const TRANSLATION_RESOURCES = {
  [LOCALES.EN]: {
    auth: auth_en,
    common: common_en,
    welcome: welcome_en,
  },
  [LOCALES.ES]: {},
  [LOCALES.FR]: {},
  [LOCALES.IT]: {},
  [LOCALES.KO]: {},
  [LOCALES.JA]: {},
};
